module.exports = __webpack_public_path__ + "img/0910f_1.bc916a7d.jpg";